/**
 * MAS Indirect-specific field change handler. Updates packSizeFormData.
 * Isolated so Indirect changes cannot affect NC or MAS Direct.
 */
import type { MASFieldChangeDeps } from './masIndirectFieldHandlers.types';

export function applyMASIndirectFieldChange(
  fieldName: string,
  processedValue: any,
  deps: MASFieldChangeDeps
): void {
  const { activePackSizeTab, setPackSizeFormData, isGlobalField, isGsmsHndlgType, isDirectProduct } =
    deps;

  if (!isGlobalField || (isGsmsHndlgType && isDirectProduct)) {
    setPackSizeFormData(prev => ({
      ...prev,
      [activePackSizeTab]: {
        ...prev[activePackSizeTab],
        [fieldName]: processedValue,
      },
    }));
  } else if (fieldName === 'analysisDate') {
    setPackSizeFormData(prev => {
      const updated = { ...prev };
      if (updated[activePackSizeTab]) {
        const { analysisDate: _analysisDateP, ...rest } = updated[activePackSizeTab];
        updated[activePackSizeTab] = rest;
      }
      return updated;
    });
  }
}
